import workoutService from '@/services/workout.service'
import { BaseAdditionalActivity, WorkoutIntensities, MssPreviewSlideData, MssHyrox, MssHyroxMainPart, HyroxWhiteboardPage } from '@/types/workouts'
import { VuexModule, Module, Mutation, Action } from 'vuex-class-modules'
import store from '../index'
import { mssWorkoutService } from '@/services/mss-workout.service'
import { unique } from '@/utils/array.utils'

@Module
class MssWorkoutsHyroxDescriptionModule extends VuexModule {

    slidesArray: MssPreviewSlideData[] = []

    workout: MssHyrox | null = null

    previewMode = false

    whiteboardPage = -1
    
    whiteboardPagesTotal = -1

    get workoutPreviewSlidesData() {
        return this.slidesArray
    }

    get workoutDescription() {
        return this.workout?.description
    }

    get tags(): string[] {
        const level = this.workout ? WorkoutIntensities.get(this.workout.difficulty) as string : ''
        const trainer = this.workout?.creatorName as string
        const duration = this.workout ? workoutService.getWorkoutDuration(this.workout) : 0
        return unique([ duration, level, trainer].flat().filter(tag => tag) as string[])
    }

    get fitnessTypeTag(): any {
        return this.workout?.type
    }

    get equipmentTags(): string[] {
        return this.workout ? this.workout.gearList : []
    }

    get durationFormat(): string {
        return this.workout ? [ Math.floor(this.workout?.totalTime / 60).toString(), 'min' ].join(' ') : ''
    }

    get coverImageUrl(): string | null {

        if (this.workout && this.workout.coverImage) {
            const { small } = this.workout.coverImage
            return !small ? null : small
        }

        return null
    }

    @Mutation
    parse(workout: MssHyrox) {
        this.workout = workout

        this.slidesArray = []

        // eslint-disable-next-line
        const { warming_ups, cooling_downs, mainParts } = workout

        // eslint-disable-next-line
        const workoutPartsArray = (warming_ups as (BaseAdditionalActivity | MssHyroxMainPart)[])
            .concat((mainParts as MssHyroxMainPart[]), cooling_downs) as (BaseAdditionalActivity | MssHyroxMainPart)[]

        for (const partIdx in workoutPartsArray) {

            // eslint-disable-next-line
            if ((workoutPartsArray[partIdx] as BaseAdditionalActivity).activity_type) {

                // eslint-disable-next-line
                const { name, activity_type, type, duration, timer, random } = workoutPartsArray[partIdx] as BaseAdditionalActivity

                const exercises = workoutService.parseExercises(workoutPartsArray[partIdx] as BaseAdditionalActivity)

                // eslint-disable-next-line
                this.slidesArray.push({ name, activity_type, type, duration, exercises, timer, random })

            }
        }
    }

    @Mutation
    updatePrviewMode(previewMode: boolean) {
        this.previewMode = previewMode
    }

    @Mutation
    setWhiteboardPage(page: number) {
        this.whiteboardPage = page
    }

    @Mutation
    setWhiteboardPagesTotal(total: number) {
        this.whiteboardPagesTotal = total
    }

    @Action
    init(workout: MssHyrox) {
        this.parse(workout)
    }

    @Action
    togglePreviewMode() {
        this.updatePrviewMode(!this.previewMode)
    }

    @Action
    swipeWhiteboardPage(page: number) {
        this.setWhiteboardPage(page)
    }

    @Action
    changeWhiteboardTotalPages(total: number)
    {
        this.setWhiteboardPagesTotal(total)
    }
}

export const mssWorkoutHyroxDescriptionModule = new MssWorkoutsHyroxDescriptionModule({ store, name: 'mssWorkoutHyroxDescriptionModule' })